import Config from 'src/common/Config';
import {
  SettingsFlow,
  RecoveryFlow,
  LoginFlow,
  RegistrationFlow,
  UiNode,
  UiNodeInputAttributes,
} from '@ory/client';
import { filterNodesByGroups, isUiNodeInputAttributes } from '@ory/integrations/ui';

interface OryApiError {
  response?: {
    data?: unknown;
    status?: number;
  };
}

export const isOryApiError = (err: unknown): err is OryApiError =>
  typeof err === 'object' && err !== null && 'response' in err;

export const rewriteActionUrl = (actionUrl: string): string => {
  if (!actionUrl) return '';
  try {
    const url = new URL(actionUrl);
    const tunnelBase = Config.getAuthBasePath();
    return `${tunnelBase}${url.pathname}${url.search}`;
  } catch {
    return actionUrl;
  }
};

export const getCsrfTokenFromFlow = (
  flow: SettingsFlow | RecoveryFlow | LoginFlow | RegistrationFlow | undefined,
): string => {
  if (!flow) return '';

  const csrfNode = flow.ui.nodes.find(
    node =>
      isUiNodeInputAttributes(node.attributes) &&
      (node.attributes as UiNodeInputAttributes).name === 'csrf_token',
  );

  return (csrfNode?.attributes as UiNodeInputAttributes | undefined)?.value ?? '';
};

export const getOidcNodesByAction = (
  flow: SettingsFlow | undefined,
  actions: string[],
): UiNode[] => {
  if (!flow) return [];

  const oidcGroupNodes = filterNodesByGroups({ nodes: flow.ui.nodes, groups: ['oidc'] });

  return oidcGroupNodes.filter(
    node =>
      isUiNodeInputAttributes(node.attributes) &&
      actions.includes((node.attributes as UiNodeInputAttributes).name),
  );
};
